import classNames from "classnames";
import Pill from "PFComponents/pill/pill";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import React, { ReactNode } from "react";

import css from "../bars.module.scss";

interface BookingTooltipContentProps {
  className?: string;
  title?: string;
  start?: string;
  end?: string;
  categoryName?: string;
  multipleInfoLabel?: string;
  multiple?: boolean;
  additionalInfo?: ReactNode;
}

const BookingTooltipContent = ({
  className,
  title,
  start,
  end,
  categoryName,
  multipleInfoLabel,
  multiple,
  additionalInfo
}: BookingTooltipContentProps): JSX.Element => {
  const { utc, formatDate } = useDateFormatter();
  const tooltipContent = multiple ? (
    <div className={css.multipleInfoLabel}>{multipleInfoLabel}</div>
  ) : (
    <>
      {(start || end) && <div>{`${formatDate(utc(start))} - ${formatDate(utc(end))}`}</div>}
      {categoryName && <Pill className={classNames(css.badge, css.category)}>{categoryName}</Pill>}
    </>
  );
  return (
    <div className={classNames(css.tooltip, className)}>
      {title && <div className={css.title}>{title}</div>}
      {tooltipContent}
      {additionalInfo}
    </div>
  );
};

export default BookingTooltipContent;
